$(document).ready(function () {
    $("#table-shipping-cost").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'get-countrys-by-ajax',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'description', name: 'description'},
            {data: 'cost', name: 'cost'},
        ],
        "columnDefs": [{
            "targets": 3,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                console.log(row)
                let status = get_global_status(row.status);


                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                    'edit-shipping-cost btn-sm m-1" data-data ="' + row + '"><i class="far fa-edit"></i></i></button> ' +

                    '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-cost-status btn-sm m-1"  ' +
                    'data-id ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +

                    '<a href="/admin/detalle-zona-envio/' + row.slug + '" data-toggle="tooltip" data-placement="top" title="Ver detalle de zona de envío" ' +
                    'class="btn btn-success  btn-sm m-1"  ' +
                    'data-id ="' + row.slug + '"><i class="fa-regular fa-rectangle-list"></i></a> ' + buttonDelete(row.status,row.slug)
            }
        }]
    });

    function buttonDelete(status,slug) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-cost-shipping btn-sm m-1"  ' +
                'data-slug ="' + slug + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ' ;
        }
        return "";

    }
    const list_shipping_cost = $("#table-shipping-cost").DataTable()

    $("#add-shipping-cost").on('click', function (e) {
        e.preventDefault()
        $("#modal-shipping-cost").modal('show')
        $("#form-shipping-cost")[0].reset()
        $('.item-payment_methods').val('').trigger("chosen:updated")
        $(".item-id").val('')
        $(".item-type").val('')
        $(".item-type").val('add')
    })

    $("#table-shipping-cost tbody").on('click', '.edit-shipping-cost', function (e) {
        e.preventDefault()
        $("#modal-shipping-cost").modal('show')
        let data = $(this).data('data')
        $(".item-type").val('edit')
        rowData = list_shipping_cost.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            $(".item-" + index).val(value)
            if (index == "payment_methods") {
                setValuePaymentMethods(value)
            }

        })
    })

    $("#table-shipping-cost tbody").on('click', '.change-cost-status', function (e) {
        e.preventDefault()
        $(".loader_").addClass("loading")
        let data = new FormData
        data.append('id', $(this).data('id'))
        sendData(data, 'change-cost-status')
    })

    $("#table-shipping-cost tbody").on('click','.delete-cost-shipping',function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('slug',$(this).data('slug'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $(".loader_").addClass("loading")
                sendData(data,'/admin/delete-shipping-cost')
            }
        })

    })

    $("#form-shipping-cost").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this);
        let type = $(".item-type").val()
        let route = type + "-shipping-cost"
        $(".loader_").addClass("loading")
        sendData(data, route)

    })

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                        $("#table-shipping-cost").DataTable().ajax.reload();
                        $("#modal-shipping-cost").modal('hide')
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }

    $("#form-shipping-cost-default").on('submit', function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        let data = new FormData(this)
        $.ajax({
            url: "/admin/update-shipping-cost-default",
            type: "post", data: data, processData: false, contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    })

    function setValuePaymentMethods(value) {
        $('.item-payment_methods').val(value)
        $('.item-payment_methods').trigger("chosen:updated")
    }

})
